import { SubscriptionStatus } from '@affine/graphql';

type SubscriptionStateLike = {
  plan?: string | null;
  status?: string | null;
  trialEnd?: string | null;
};

export function isTrialingSubscriptionCurrent(
  subscription: SubscriptionStateLike | null | undefined,
  now = Date.now()
): boolean {
  if (subscription?.status !== SubscriptionStatus.Trialing) {
    return false;
  }
  if (!subscription.trialEnd) {
    return false;
  }
  return new Date(subscription.trialEnd).getTime() > now;
}

export function isDisplayableBillingSubscription(
  subscription: SubscriptionStateLike | null | undefined,
  now = Date.now()
): boolean {
  if (!subscription?.plan || subscription.plan === 'Free') {
    return false;
  }
  if (subscription.status === SubscriptionStatus.Trialing) {
    return isTrialingSubscriptionCurrent(subscription, now);
  }
  return (
    subscription.status === SubscriptionStatus.Active ||
    subscription.status === SubscriptionStatus.PastDue ||
    subscription.status === SubscriptionStatus.Unpaid ||
    subscription.status === SubscriptionStatus.Incomplete
  );
}
